import { Icon, IconsEnum } from 'components/Icons';
import { RadioButton } from 'components/inputs/radioButton';
import useOutsideAlerter from 'hooks/useClickOutside';
import { useMemo, useRef, useState } from 'react';
import { isClientSide } from 'utility/constant';
import styles from './DropdownRadioMenuFilter.module.scss';

export type DropdownRadioMenuFilterProps = {
  label: string;
  selectedItem?: { label: string; value: string };
  listOfItems: Array<{ label: string; value: string }>;
  handleFilterChange: (el: { label: string; value: string }) => void;
};

export const DropdownRadioMenuFilter = ({
  listOfItems,
  label,
  selectedItem,
  handleFilterChange,
}: DropdownRadioMenuFilterProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const { leftView, positionX } = useMemo(() => {
    let leftView = 0;
    let positionX = 0;

    if (isClientSide && wrapperRef.current) {
      leftView = window.innerWidth * 0.5;
      positionX = wrapperRef.current.getBoundingClientRect().x;
    }

    return {
      leftView,
      positionX,
    };
  }, []);

  useOutsideAlerter({
    ref: wrapperRef,
    onClickOutside: () => setIsOpen(false),
  });

  return (
    <div className={styles.container} ref={wrapperRef}>
      <button type="button" className={styles.button} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.label}>
          {label}
          {selectedItem && <p>{selectedItem.label}</p>}
        </div>
        <Icon
          iconId={IconsEnum.CHEVRON_DOWN}
          className={`${styles.icon} ${isOpen ? styles.rotate : ''}`}
          color={'var(--color-on-bg-primary)'}
        />
      </button>
      <ul
        className={
          positionX! > leftView
            ? `${styles.list} ${isOpen ? styles.open : ''} ${styles.absoluteRight}`
            : `${styles.list} ${isOpen ? styles.open : ''} `
        }
      >
        {listOfItems.map((item, id: number) => {
          return (
            <li className={styles.item} key={id}>
              <RadioButton
                name={`${item.value}-${label}`}
                defaultValue={selectedItem?.value}
                options={[
                  {
                    label: item.label,
                    value: item.value,
                  },
                ]}
                onChange={(el) => {
                  handleFilterChange(item);
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
